<script>
export default {
  name: 'CheckboxGroup',
  props: {
    selectedItems: { type: Array, required: true },
    items: { type: Array, required: true },
    disabled: { type: Boolean, default: false },
    max: { type: Number, validator: (v) => v >= 1 },
    direction: {
      type: String,
      default: 'column',
      validator: (v) => ['row', 'column'].includes(v),
    },
  },
  computed: {
    // el-checkbox-group の v-model 用プロキシ
    proxyValue: {
      get() {
        return this.selectedItems
      },
      set(val) {
        this.onSelectionChange(val)
      },
    },
  },
  methods: {
    onSelectionChange(newSelectedValues) {
      // 上限超過時は親へ反映しない（v-model は props で即時に戻る）
      if (this.max !== undefined && newSelectedValues.length > this.max) return
      this.$emit('update:selectedItems', newSelectedValues)
    },
    isDisabled(item) {
      const isMaxReached =
        this.max &&
        !this.selectedItems.includes(item.value) &&
        this.selectedItems.length >= this.max
      return this.disabled || item.disabled || isMaxReached
    },
  },
}
</script>

<template>
  <el-checkbox-group v-model="proxyValue">
    <div class="checkbox-items" :class="`direction-${direction}`">
      <div v-for="item in items" :key="item.value" class="checkbox-item">
        <!-- Element UI は group では :label を値として使う -->
        <el-checkbox :label="item.value" :disabled="isDisabled(item)">
          {{ item.label }}
        </el-checkbox>
      </div>
    </div>
  </el-checkbox-group>
</template>

<style scoped>
/deep/ .checkbox-items {
  display: flex;
}

:deep(.direction-row) {
  flex-direction: row;
  flex-wrap: wrap;
}

:deep(.direction-column) {
  flex-direction: column;
}

/* 横並びの時だけ横のマージンを確保 */
:deep(.direction-row .checkbox-item) {
  margin-right: 14px;
}
</style>
